var WindBarb = (function () {
  function WindBarb (size) {
    // 当前羽的间隔和杆高度能画出的最大风速，如果需要画更大风速，请调整这两项的值。
    this.maxWinds = 72
    this.windbarbWidth = size
    this.windbarbHeight = size * 2
    // 羽的间隔距离
    this.interval = this.windbarbHeight / 7.8
    // 线的宽度
    this.lineWidth = this.windbarbHeight / 15
    this.icons = {}

    // 测试
  }
  WindBarb.prototype = {
    getIconOfCanvas (winds, customColor) {
      const _this = this
      const windIcon = winds < 2 ? 1 : winds - (winds % 2)
      if (_this.icons[windIcon]) {
        return _this.icons[windIcon]
      }
      const canvas = document.createElement('canvas')
      canvas.width = _this.windbarbWidth
      canvas.height = _this.windbarbHeight
      const context = canvas.getContext('2d')
      context.lineWidth = _this.lineWidth
      context.strokeStyle = _this.getColor(windIcon, customColor)
      _this.createWindBarb(context, windIcon)
      _this.icons[windIcon] = canvas
      return canvas
    },
    createWindBarb (context, windIcon) {
      const _this = this
      const minX = _this.lineWidth / 2 + 1
      const maxX = _this.windbarbWidth - 1
      let currentY = _this.lineWidth / 2
      if (windIcon >= 4 && windIcon < 20) {
        context.beginPath()
        context.moveTo(minX, _this.interval)
        context.lineTo(minX, _this.windbarbHeight)
      } else {
        context.beginPath()
        context.moveTo(minX, 0)
        context.lineTo(minX, _this.windbarbHeight)
      }
      // 画20米/秒
      const numByTwenty = parseInt(windIcon / 20)
      if (numByTwenty > 0) {
        for (let i = 0; i < numByTwenty; i++) {
          const minY = _this.interval * i + _this.lineWidth / 2 * (i + 1)
          currentY = _this.interval * (i + 1) + _this.lineWidth / 2 * (i + 1)
          context.moveTo(minX, currentY)
          context.lineTo(maxX, minY)
          context.moveTo(minX, minY)
          context.lineTo(maxX, minY)
        }
      }
      // 画4米/秒
      const numByFour = parseInt((windIcon % 20) / 4)
      if (numByFour > 0) {
        for (let i = 0; i < numByFour; i++) {
          currentY = currentY + _this.interval
          context.moveTo(minX, currentY)
          context.lineTo(maxX, currentY - _this.interval)
        }
      }
      // 画2米/秒
      const numByTwo = parseInt(((windIcon % 20) % 4) / 2)
      if (numByTwo > 0) {
        currentY = currentY + _this.interval
        context.moveTo(minX, currentY)
        context.lineTo(maxX - _this.windbarbWidth / 2 + 2, currentY - _this.interval / 2)
      }
      context.stroke()
    },
    getColor (windIcon, customColor) {
      if (windIcon <= 2) {
        // return '#00646477'
        if (customColor) {
          return customColor
        } else {
          return '#FFF'
        }
      } else if (windIcon <= 4) {
        return '#00640077'
      } else if (windIcon <= 8) {
        return '#646432AA'
      } else {
        return '#ff0000'
      }
    }
  }
  return WindBarb
}())
export default WindBarb
